import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import modules from './modules'
const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules,
  strict: debug,
  plugins: debug ? [createLogger()] : []
})

// smodel获取route信息
global.__ROUTE_STORE__ = store.state

export default store



// WEBPACK FOOTER //
// ./src/store/index.js